var _path, _path2, _rect, _g, _rect2, _path3, _circle, _circle2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19043 19.6381C6.19043 17.9435 7.53449 16.5543 9.22816 16.4984L63.5744 14.7039C65.349 14.6453 66.8194 16.068 66.8194 17.8436V53.8491C66.8194 55.5437 65.4754 56.9329 63.7817 56.9888L9.43551 58.7833C7.66089 58.8419 6.19043 57.4192 6.19043 55.6436V19.6381Z",
    fill: "#9266CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19709 15.5566L63.5433 13.762C65.8503 13.6859 67.7619 15.5354 67.7619 17.8436V53.8492C67.7619 56.0521 66.0146 57.8581 63.8129 57.9308L9.46665 59.7253C7.15965 59.8015 5.24805 57.9519 5.24805 55.6437V19.6382C5.24805 17.4352 6.99532 15.6293 9.19709 15.5566ZM9.22819 16.4985C7.53453 16.5544 6.19047 17.9436 6.19047 19.6382V55.6437C6.19047 57.4193 7.66093 58.842 9.43554 58.7834L63.7818 56.9889C65.4754 56.9329 66.8195 55.5438 66.8195 53.8492V17.8436C66.8195 16.0681 65.349 14.6453 63.5744 14.7039L9.22819 16.4985Z",
    fill: "#9266CC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.6318,
    y: 42.5381,
    width: 56.8116,
    height: 34.8745,
    rx: 5,
    transform: "rotate(172.038 67.6318 42.5381)",
    fill: "#87BB69"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.0527,
    y: 15.0654,
    width: 9.40987,
    height: 6.68741,
    rx: 1.25,
    transform: "rotate(-7.96248 49.0527 15.0654)",
    fill: "#82FDB6",
    stroke: "#1AAF59",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.0756,
    y1: 17.0069,
    x2: 49.6441,
    y2: 17.4868,
    stroke: "#1AAF59",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.3149,
    y1: 18.7222,
    x2: 49.8834,
    y2: 19.2022,
    stroke: "#1AAF59",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.4682,
    y1: 16.2525,
    x2: 55.0367,
    y2: 16.7325,
    stroke: "#1AAF59",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.7085,
    y1: 17.9683,
    x2: 55.2769,
    y2: 18.4483,
    stroke: "#1AAF59",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9062,
    y: 15.7803,
    width: 1.72747,
    height: 3.95493,
    rx: 0.863733,
    transform: "rotate(-7.96248 52.9062 15.7803)",
    stroke: "#1AAF59",
    strokeWidth: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.50391,
    y: 18.3662,
    width: 60.0007,
    height: 41.7806,
    rx: 4,
    fill: "#AA8DD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4258 36.7435C51.4258 33.7074 53.8871 31.2461 56.9232 31.2461H67.0071C69.1585 31.2461 70.9025 32.9901 70.9025 35.1414V38.3457C70.9025 40.497 69.1585 42.241 67.0071 42.241H56.9232C53.8871 42.241 51.4258 39.7797 51.4258 36.7435Z",
    fill: "#9266CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.9235,
    cy: 36.7438,
    r: 3.29847,
    fill: "#FAFAFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0919,
    cy: 48.2824,
    r: 9.70229,
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1667 47.5262C34.1667 56.9611 26.5182 64.6095 17.0833 64.6095C7.64847 64.6095 0 56.9611 0 47.5262C0 38.0913 7.64847 30.4429 17.0833 30.4429C26.5182 30.4429 34.1667 38.0913 34.1667 47.5262ZM11.9064 42.3494C12.4068 41.849 13.218 41.849 13.7184 42.3494L17.0833 45.7142L20.4481 42.3494C20.9485 41.849 21.7597 41.849 22.2601 42.3494C22.7604 42.8498 22.7604 43.661 22.2601 44.1614L18.8952 47.5262L22.26 50.891C22.7604 51.3913 22.7604 52.2026 22.26 52.703C21.7597 53.2033 20.9484 53.2033 20.4481 52.703L17.0833 49.3382L13.7184 52.703C13.2181 53.2033 12.4068 53.2033 11.9065 52.703C11.4061 52.2026 11.4061 51.3914 11.9065 50.891L15.2713 47.5262L11.9064 44.1613C11.4061 43.661 11.4061 42.8497 11.9064 42.3494Z",
    fill: "#D11A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4ee3af8e45b435e4d5cd0898c9b16094.svg";
export { ForwardRef as ReactComponent };